import { type UseLocationHref } from './types';

const isLocationAvailable = (): boolean =>
	typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';

export const useLocationHref = (): UseLocationHref => {
	return isLocationAvailable() ? globalThis.location.href : undefined;
};
